module.exports = __webpack_public_path__ + "img/brush-03.896b8092.svg";